(function () {
  'use strict';
  var active;

  function suspend() {
    if (!active) return;
    active.stopped = true;
    active.observer.disconnect();
    if (active.controller) active.controller.abort();
    active = null;
  }

  function reset() {
    suspend();
    if (!window.IntersectionObserver || !window.fetch || !window.AbortController) return;
    var grid = document.querySelector('#js-product-ajax [data-collection-grid]');
    var pagination = document.querySelector('#js-product-ajax [data-collection-pagination]');
    var status = document.querySelector('#js-product-ajax [data-collection-loading]');
    if (!grid || !pagination || !status || !pagination.dataset.nextUrl) return;

    var state = {
      stopped: false, loading: false, visited: new Set(),
      products: new Set(Array.from(grid.children).map(function (card) { return card.dataset.productId; })),
      location: window.location.href, next: pagination.dataset.nextUrl
    };
    active = state;
    pagination.style.display = 'none';
    status.hidden = false;
    status.textContent = '';

    function nextUrl(value) {
      var base = new URL(state.location);
      var url = new URL(value, base);
      base.searchParams.forEach(function (value, key) {
        if (key !== 'page' && !url.searchParams.has(key)) url.searchParams.set(key, value);
      });
      if (url.origin !== base.origin || url.pathname !== base.pathname) throw new Error('Invalid pagination URL');
      var page = Number(url.searchParams.get('page'));
      if (!Number.isInteger(page) || page <= Number(base.searchParams.get('page') || 1)) throw new Error('Invalid next page');
      var currentQuery = new URLSearchParams(base.search);
      var nextQuery = new URLSearchParams(url.search);
      currentQuery.delete('page'); nextQuery.delete('page');
      currentQuery.sort(); nextQuery.sort();
      if (currentQuery.toString() !== nextQuery.toString()) throw new Error('Collection state changed');
      return url.href;
    }

    async function load() {
      if (state.stopped || state.loading || !state.next) return;
      if (window.location.href !== state.location || !grid.isConnected) { suspend(); return; }
      state.loading = true;
      state.observer.disconnect();
      status.textContent = 'Loading more watches…';
      grid.setAttribute('aria-busy', 'true');
      state.controller = new AbortController();
      var timeout = setTimeout(function () { state.controller.abort(); }, 15000);
      try {
        var url = nextUrl(state.next);
        if (state.visited.has(url)) throw new Error('Repeated pagination page');
        state.visited.add(url);
        var response = await fetch(url, { signal: state.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Pagination request failed');
        var html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (state.stopped || window.location.href !== state.location || !grid.isConnected) return;
        var nextGrid = html.querySelector('#js-product-ajax [data-collection-grid]');
        if (!nextGrid) throw new Error('Missing product grid');
        var cards = Array.from(nextGrid.children).filter(function (card) {
          return card.dataset.productId && !state.products.has(card.dataset.productId);
        });
        if (!cards.length) throw new Error('No new products');
        var fragment = document.createDocumentFragment();
        cards.forEach(function (card) {
          if (state.products.has(card.dataset.productId)) return;
          state.products.add(card.dataset.productId);
          fragment.appendChild(card);
        });
        grid.appendChild(fragment);
        var nextPagination = html.querySelector('[data-collection-pagination]');
        state.next = nextPagination ? nextPagination.dataset.nextUrl : '';
        pagination.innerHTML = nextPagination ? nextPagination.innerHTML : '';
        pagination.dataset.nextUrl = state.next;

        // Reuse the theme's existing AJAX card initialization; click handlers are delegated.
        ['wishlist', 'compare', 'countdown', 'tooltip', 'swatchCard2'].forEach(function (name) {
          if (theme[name] && theme[name].load) theme[name].load();
        });
        if (theme.priceRange) theme.priceRange.load(true);
        if (theme.collectionView) theme.collectionView.triggerView();
        if (window.lazySizes) window.lazySizes.loader.checkElems();
        status.textContent = '';
        if (!state.next) { state.stopped = true; status.hidden = true; }
      } catch (error) {
        if (!state.stopped) {
          state.stopped = true;
          status.textContent = 'More watches could not be loaded. Please use the page links below.';
          pagination.style.display = '';
        }
      } finally {
        clearTimeout(timeout);
        state.loading = false;
        grid.removeAttribute('aria-busy');
        if (!state.stopped) state.observer.observe(status);
      }
    }

    state.observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) load();
    }, { rootMargin: '0px 0px 300px 0px' });
    state.observer.observe(status);
  }

  theme.collectionInfiniteScroll = { reset: reset, suspend: suspend };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reset, { once: true });
  else reset();
  window.addEventListener('pagehide', suspend);
  window.addEventListener('pageshow', function (event) { if (event.persisted) reset(); });
})();
